import React, { useEffect, useRef, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import CorporatePage from "./FrontPages/Corporate/corporatePage";
import InquiryPage from "./FrontPages/Inquiry/inquiryPage";
import designAndDecor from "./FrontPages/DesignAndDecor/designAndDecor";
import { corefetch, ImageURL } from "../Util/axios_core_helper";
import rentalGuidlinesDetails from "./FrontPages/DesignAndDecor/rentalGuidlinesDetails";
import categoriesDetails from "./FrontPages/DesignAndDecor/categoriesDetails";
import DecorationCategoryDetails from "./FrontPages/DesignAndDecor/decorationCategoryDetails";
import { RentalItem } from "./FrontPages/DesignAndDecor/rentalItem";
import cart from "./FrontPages/DesignAndDecor/cart";
import Cart from "./FrontPages/DesignAndDecor/cart";
import { CartList } from "./FrontPages/DesignAndDecor/cartList";
import { ToastContainer } from "react-toastify";
import { Helmet } from "react-helmet";

const LayoutCorporate = () => {
  const [InquiryModal, setInquiryModal] = useState(false);
  const [CloseModal, setCloseModal] = useState(1);
  const [loadComponent, setloadComponent] = useState(null);
  const [socialLinks, setSocialLinks] = useState(null);
  const [ContactList, setContactList] = useState([]);
  const [BallroomData, setBallroomData] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const [cartItemCount, setCartItemCount] = useState(0);
  const [socialMediaLinks, setSocialMediaLinks] = useState([]);
  const [isCollapsed, setIsCollapsed] = useState(true); // Track collapse state
  const [isExpanded, setIsExpanded] = useState(false); // Track aria-expanded state
  const navigate = useNavigate();
  const activeMenu = window.location.href.split("/").pop().toLowerCase();
  const dropdownRef = useRef(null);
  const navbarRef = useRef(null);
  const togglerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const ResetModal = (e) => {
    setloadComponent(
      <InquiryPage InquiryModal={InquiryModal} ResetModal={ResetModal} />
    );
    setCloseModal((prevkey) => prevkey + 1);
  };

  useEffect(() => {
    if (!loadComponent && InquiryModal) {
      setloadComponent(
        <InquiryPage InquiryModal={InquiryModal} ResetModal={ResetModal} />
      );
    }
  }, [InquiryModal]);

  const openModal = (e) => {
    e.preventDefault();
    $("#inquiry").modal("show");
    setInquiryModal(true);
  };

  const fetchBallroomData = async () => {
    try {
      const list = await corefetch("Facility/GetActiveBallroomData");
      if (list && list.length > 0) {
        setBallroomData(list);
      }
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };

  const fetchContactListData = async () => {
    try {
      const list = await corefetch("ContactUs/GetContactList");
      if (list && list.length > 0) {
        setContactList(list);
      } else {
        setContactList([]);
      }
    } catch (error) {
      setContactList([]);
      console.error("Error fetching list:", error);
    }
  };

  const fetchSocialMediaData = async () => {
    try {
      const response = await corefetch("ContactUs/SocialMediaLinksForFrontend");
      if (response && response.length > 0) {
        setSocialLinks(response[0]);
      } else {
        console.log("No data found on SocialMediaLinksForFrontend");
      }
    } catch (error) {
      console.error("Error fetching social media links:", error);
    }
  };

  useEffect(() => {
    fetchContactListData();
    fetchBallroomData();
    fetchSocialMediaData();
  }, []);

  const handleNavbarToggle = () => {
    setIsCollapsed((prev) => !prev);
  };

  // Handle dropdown toggle
  const handleDropdownToggle = (event, dropdownId) => {
    event.preventDefault();
    event.stopPropagation();
    setOpenDropdown((prev) => (prev === dropdownId ? null : dropdownId));
  };

  // Single useEffect for all click-outside logic
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Close navbar if clicked outside
      if (
        navbarRef.current &&
        !navbarRef.current.contains(event.target) &&
        togglerRef.current &&
        !togglerRef.current.contains(event.target)
      ) {
        setIsCollapsed(true);
      }

      // Close dropdowns if clicked outside
      if (!event.target.closest(".nav-item.dropdown")) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Apply `show/collapsed` classes based on React state (no direct DOM manipulation)
  useEffect(() => {
    const navbarToggle = document.querySelector(".navbar-toggler");
    const navbarCollapse = document.querySelector(".navbar-collapse");

    if (navbarToggle && navbarCollapse) {
      if (isCollapsed) {
        navbarToggle.classList.add("collapsed");
        navbarToggle.setAttribute("aria-expanded", "false");
        navbarCollapse.classList.remove("show");
      } else {
        navbarToggle.classList.remove("collapsed");
        navbarToggle.setAttribute("aria-expanded", "true");
        navbarCollapse.classList.add("show");
      }
    }
  }, [isCollapsed]);

  useEffect(() => {
    const updateCartCount = () => {
      const storedCart = localStorage.getItem("cart_items");
      let cartItems = storedCart ? JSON.parse(storedCart) : [];

      // Get the number of unique items in the cart
      const itemCount = cartItems.length;

      $("#cart-count").text(itemCount > 0 ? itemCount : "0");
    };

    updateCartCount();

    // Listen for cart updates
    window.addEventListener("cartUpdated", updateCartCount);

    return () => {
      window.removeEventListener("cartUpdated", updateCartCount);
    };
  }, []);

  useEffect(() => {
    const fetchSocialMediaLinkData = async () => {
      try {
        const response = await corefetch("ContactUs/GetSocialMediaLinkDetails");
        if (response && response.length > 0) {
          setSocialMediaLinks(response);
        } else {
          console.log("No data found on SocialMediaLinksForFrontend");
          setSocialMediaLinks([]);
        }
      } catch (error) {
        console.error("Error fetching social media links:", error);
        setSocialMediaLinks([]);
      }
    };

    fetchSocialMediaLinkData();
  }, []);
  useEffect(() => {
    const handlePopState = () => {
      window.location.reload();
    };

    window.addEventListener("popstate", handlePopState);
    window.onpageshow = function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    };

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, []);

  return (
    <>
      <Helmet>
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=G-K37D8DFFDY"
        ></script>
        <script>
          {`
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', 'G-K37D8DFFDY');
      `}
        </script>
        <script
          async
          // src="https://tag.pearldiver.io/ldc.js?pid=c450c9fa544f18c430bdd02a1b14c91f&aid=16de03f2"
        ></script>

        <script type="text/javascript" defer>
          {`
        var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
        (function () {
          var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
          s1.async = true;
          s1.src = 'https://embed.tawk.to/59337a50b3d02e11ecc6821d/default';
          s1.charset = 'UTF-8';
          s1.setAttribute('crossorigin', '*');
          s0.parentNode.insertBefore(s1, s0);
        })();
      `}
        </script>
      </Helmet>
      <div className="page-wrapper">
        <div>
          <div className="progress-wrap cursor-pointer">
            <svg
              className="progress-circle svg-content"
              width="100%"
              height="100%"
              viewBox="-1 -1 102 102"
            >
              <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
            </svg>
          </div>
          <nav
            className="navbar navbar-expand-lg"
            style={{ marginBottom: "5px" }}
          >
            <div className="container">
              <div className="logo-wrapper">
                <a className="logo" href="/home">
                  <img
                    src="/assets/images/corporate-img/img/logo/Meridian-lightlogo.png"
                    className="logo-img"
                    alt="Meridian-lightlogo"
                  />
                </a>
              </div>
              <button
                ref={togglerRef}
                className={`navbar-toggler ${isCollapsed ? "collapsed" : ""}`}
                type="button"
                aria-controls="navbar"
                aria-expanded={!isCollapsed}
                aria-label="Toggle navigation"
                onClick={handleNavbarToggle}
              >
                <span className="navbar-toggler-icon">
                  <i className="ti-menu" />
                </span>
              </button>

              <div
                ref={navbarRef}
                className={`navbar-collapse collapse ${
                  isCollapsed ? "" : "show"
                }`}
                id="navbar"
                style={{ marginRight: "37px" }}
              >
                <ul className="navbar-nav ms-auto">
                  <li className="nav-item">
                    <a className="nav-link" href="/home">
                      HOME
                    </a>
                  </li>
                  <li className="nav-item dropdown ">
                    <a
                      // className="nav-link dropdown-toggle show"
                      className={
                        activeMenu === "corporate"
                          ? "corporate-item active nav-link dropdown-toggle show"
                          : "nav-link dropdown-toggle show"
                      }
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded={true}
                    >
                      EVENTS <i className="ti-angle-down "></i>
                    </a>
                    <ul className="dropdown-menu show" data-bs-popper="static">
                      <li>
                        <a href="/quinceanera" className="dropdown-item">
                          <span>Quinceanera</span>
                        </a>
                      </li>
                      <li>
                        <a href="/wedding" className="dropdown-item">
                          <span>Wedding</span>
                        </a>
                      </li>
                      <li>
                        <a
                          href="/corporate"
                          className={
                            activeMenu === "corporate"
                              ? "corporate-item active"
                              : ""
                          }
                        >
                          <span>Corporate</span>
                        </a>
                      </li>
                      <li className="dropdown-submenu dropdown">
                        <a
                          className="dropdown-item dropdown-toggle"
                          data-bs-auto-close="outside"
                          aria-expanded={true}
                          href="/privateparties"
                        >
                          <span>
                            Private Parties
                            <i
                              className="fa fa-angle-right dropdown-arrow"
                              style={{
                                padding: "5px",
                                fontSize: "16px",
                                float: "right",
                                fontWeight: "bold",
                                color: "white",
                                backgroundColor: "#ac8656",
                              }}
                            ></i>
                          </span>
                        </a>
                        <ul className="dropdown-menu show">
                          <li>
                            <a href="/birthday" className="dropdown-item">
                              <span>Birthday</span>
                            </a>
                          </li>
                          <li>
                            <a href="/babyshower" className="dropdown-item">
                              <span>Baby Shower</span>
                            </a>
                          </li>
                          <li>
                            <a href="/graduation" className="dropdown-item">
                              <span>Graduation</span>
                            </a>
                          </li>
                          <li>
                            <a href="/engagement" className="dropdown-item">
                              <span>Engagement</span>
                            </a>
                          </li>
                          <li>
                            <a href="/others" className="dropdown-item">
                              <span>Others</span>
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle show"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded={true}
                    >
                      VENUES <i className="ti-angle-down show"></i>
                    </a>
                    <ul className="dropdown-menu show">
                      {BallroomData.map((ballroom) => (
                        <li key={ballroom.facilityID} className="dropdown-item">
                          <a href={`/facilityMain/${ballroom.facilityID}`}>
                            <span> {ballroom.facilityName}</span>
                          </a>
                          <br />
                        </li>
                      ))}
                    </ul>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/about-us">
                      ABOUT US
                    </a>
                  </li>
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded={true}
                    >
                      GALLERY <i className="ti-angle-down show"></i>
                    </a>

                    <ul className="dropdown-menu show">
                      {BallroomData.map((ballroom) => (
                        <li key={ballroom.facilityID} className="dropdown-item">
                          <a
                            href={`/gallery/${ballroom.facilityID}/BallRoom`}
                            // className="Footer-title-list-value"
                          >
                            {ballroom.facilityName}
                          </a>
                          <br />
                        </li>
                      ))}
                    </ul>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/ContactUs">
                      CONTACT US
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#" onClick={openModal}>
                      INQUIRY
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className={`nav-link ${
                        activeMenu == "design-decor" ? "active" : ""
                      }`}
                      href="/design-decor"
                    >
                      DESIGN / DECOR
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="/vendor">
                      VENDOR
                    </a>
                  </li>
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#"
                      role="button"
                      data-bs-toggle="dropdown"
                      data-bs-auto-close="outside"
                      aria-expanded={true}
                    >
                      BLOG <i className="ti-angle-down show"></i>
                    </a>
                    <ul className="dropdown-menu show">
                      <li>
                        <a href="/Blogs/2" className="dropdown-item">
                          <span>Quinceanera</span>
                        </a>
                      </li>
                      <li>
                        <a href="/Blogs/3" className="dropdown-item">
                          <span>Wedding</span>
                        </a>
                      </li>
                      <li>
                        <a href="/Blogs/4" className="dropdown-item">
                          <span>Corporate</span>
                        </a>
                      </li>
                      <li className="dropdown-submenu dropdown">
                        <a
                          className="dropdown-item dropdown-toggle"
                          data-bs-auto-close="outside"
                          aria-expanded={true}
                          href="/Blogs/5"
                        >
                          <span>
                            Private Parties{" "}
                            <i
                              className="fa fa-angle-right dropdown-arrow"
                              style={{
                                padding: "5px",
                                fontSize: "16px",
                                float: "right",
                                fontWeight: "bold",
                                color: "white",
                                backgroundColor: "#ac8656",
                              }}
                            ></i>
                          </span>
                        </a>
                        <ul className="dropdown-menu blog show">
                          <li>
                            <a href="/Blogs/15" className="dropdown-item">
                              <span>Birthday</span>
                            </a>
                          </li>
                          <li>
                            <a href="/Blogs/16" className="dropdown-item">
                              <span>Baby Shower</span>
                            </a>
                          </li>
                          <li>
                            <a href="/Blogs/17" className="dropdown-item">
                              <span>Graduation</span>
                            </a>
                          </li>
                          <li>
                            <a href="/Blogs/18" className="dropdown-item">
                              <span>Engagement</span>
                            </a>
                          </li>
                          <li>
                            <a href="/Blogs/19" className="dropdown-item">
                              <span>Others</span>
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>

              {/* <div className="mini-cart">
                <button
                  className="cart-toggle-btn"
                  style={{ marginRight: "54px", fontSize: "25px" }}
                >
                  <a href="/paymentMethods" title="Payment">
                    <i
                      id="payment-icon"
                      className="fa fa-usd icon-size iconColor payment"
                      style={{ color: "white" }}
                    />
                  </a>
                </button>
              </div> */}
              <div className="mini-cart">
                <a href="/paymentMethods" title="Payment">
                  <button
                    className="cart-toggle-btn"
                    style={{
                      marginRight: "54px",
                      fontSize: "25px",
                      border: "none",
                      background: "transparent",
                      padding: "10px 15px",
                    }}
                  >
                    <i
                      id="payment-icon"
                      className="fa fa-usd icon-size iconColor payment"
                      style={{
                        color: "white",
                        transition: "transform 0.3s ease, color 0.3s ease",
                      }}
                    />
                  </button>
                </a>
              </div>
              {/* <div className="mini-cart">
                <button
                  className="cart-toggle-btn"
                  style={{ fontSize: "25px" }}
                >
                  <a href="/cartList" title="Cart">
                    <i
                      id="cart-icon"
                      className="fa fa-shopping-cart icon-size iconColor cart"
                      style={{ color: "white" }}
                    />
                    <span className="cart-count-badge" id="cart-count"></span>
                  </a>
                </button>
              </div> */}
              <div className="mini-cart">
                <a href="/cartList" title="Cart">
                  <button
                    className="cart-toggle-btn"
                    style={{
                      fontSize: "25px",
                      border: "none",
                      background: "transparent",
                      padding: "10px 15px",
                    }}
                  >
                    <i
                      id="cart-icon"
                      className="fa fa-shopping-cart icon-size iconColor cart"
                      style={{
                        color: "white",
                        transition: "transform 0.3s ease, color 0.3s ease",
                      }}
                    />
                    <span className="cart-count-badge" id="cart-count"></span>
                  </button>
                </a>
              </div>
            </div>
          </nav>
        </div>
        <div className="color-switcher-wrap">
          <div className="floating-icons-wrap">
            <ul className="floating-icons">
              <li
                className="icon-btn"
                title="Brochure"
                ref={dropdownRef}
                onClick={(e) => {
                  e.preventDefault();
                  setIsOpen((prev) => !prev);
                }}
              >
                <a href="#">
                  <i className="fa fa-newspaper-o icon-size" />
                  <span className="icon-label">Smart Brochure</span>
                </a>

                {isOpen && (
                  <div className="dropdown-container">
                    <ul className="brochure-dropdown brochure-dropdown-left">
                      <li
                        style={{
                          margin: "9px 2px",
                          borderBottom: "1px solid #ddd",
                        }}
                      >
                        <a
                          href={socialLinks && socialLinks.broucherLink}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Social Events
                        </a>
                      </li>

                      <li style={{ marginLeft: "1px" }}>
                        <a
                          href={
                            socialLinks && socialLinks.corporateBroucherLink
                          }
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Corporate Events
                        </a>
                      </li>
                    </ul>
                  </div>
                )}
              </li>
              <li
                className="icon-btn"
                title={`Contact Us:${socialLinks && socialLinks.contact}`}
              >
                <a href={`tel:+${socialLinks?.contact}`}>
                  <i className="fa fa-phone icon-size" />
                  <span className="icon-label">{socialLinks?.contact}</span>
                </a>
              </li>
              <li
                className="icon-btn"
                title="Email Us"
                onClick={(e) => {
                  e.stopPropagation(); // Prevents unwanted event bubbling
                  if (socialLinks?.emailId) {
                    window.location.href = `mailto:${socialLinks.emailId}`;
                  }
                }}
              >
                <a href={`mailto:${socialLinks && socialLinks.emailId}`}>
                  <i className="fa fa-envelope icon-size" />
                  <span className="icon-label">Email Us</span>
                </a>
              </li>

              <li
                className="icon-btn"
                title="Play Store"
                onClick={(e) => {
                  e.stopPropagation(); // Prevents unwanted event bubbling
                  if (socialLinks?.playStoreURL) {
                    window.open(
                      socialLinks.playStoreURL,
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }
                }}
              >
                <a
                  href={socialLinks && socialLinks.playStoreURL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-android icon-size" />
                  <span className="icon-label">Play Store</span>
                </a>
              </li>

              <li
                className="icon-btn"
                title="App Store"
                onClick={(e) => {
                  e.stopPropagation(); // Prevents unwanted event bubbling
                  if (socialLinks?.appStoreURL) {
                    window.open(
                      socialLinks.appStoreURL,
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }
                }}
              >
                <a
                  href={socialLinks && socialLinks.appStoreURL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="fa fa-apple icon-size" />
                  <span className="icon-label">App Store</span>
                </a>
              </li>

              <li
                className="icon-btn"
                title="Inquiry"
                onClick={openModal}
                style={{ cursor: "pointer" }}
              >
                <a onClick={(e) => e.preventDefault()}>
                  <i className="fa fa-paper-plane icon-size" />
                  <span className="icon-label">Inquiry</span>
                </a>
              </li>
            </ul>
          </div>
          {/* <div className="color-switcher-item">
            <div className="color-toggle-btn">
              <i className="fa fa-cog" />
            </div>
            <ul id="switcher">
              <li className="btn btn1" id="Button1" />
              <li className="btn btn2" id="Button2" />
              <li className="btn btn3" id="Button3" />
              <li className="btn btn4" id="Button4" />
              <li className="btn btn5" id="Button5" />
              <li className="btn btn6" id="Button6" />
              <li className="btn btn7" id="Button7" />
              <li className="btn btn8" id="Button8" />
              <li className="btn btn9" id="Button9" />
              <li className="btn btn10" id="Button10" />
              <li className="btn btn11" id="Button11" />
              <li className="btn btn12" id="Button12" />
            </ul>
          </div> */}
        </div>
        <div className="Container-fluid" style={{ minHeight: "500px" }}>
          <Routes>
            <Route path="/corporate" Component={CorporatePage} />
            <Route path="/Design-Decor" Component={designAndDecor} />
            <Route
              path="/RentalGuidlinesdetails"
              Component={rentalGuidlinesDetails}
            />
            <Route path="/categoriesdetails" Component={categoriesDetails} />
            <Route
              path="/decorationcategorydetails"
              Component={DecorationCategoryDetails}
            />
            <Route path="/rentalitem/:categoryid" element={<RentalItem />} />
            <Route path="/cart/:itemid" element={<Cart />} />
            <Route path="/cartList" Component={CartList} />
          </Routes>
        </div>
        <footer className="footer">
          <div className="top">
            <div className="container">
              <div className="row">
                {socialMediaLinks.length > 0 && (
                  <div className="col-md-2 mb-30">
                    <div className="sub-title border-footer-light whte">
                      Follow Us
                    </div>
                    <div className="item">
                      <div className="social mt-2">
                        {socialMediaLinks.map((social, index) => (
                          <a
                            title={social.name}
                            key={index}
                            href={social.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ cursor: "pointer" }}
                          >
                            <img
                              src={`${ImageURL}${social.imagePath}`}
                              alt={social.name}
                            />
                          </a>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                <div className="col-md-3 offset-md-1">
                  <div className="item">
                    <h3>Contact Us</h3>
                    {ContactList != null &&
                      ContactList.length > 0 &&
                      ContactList?.map(
                        (contact, index) =>
                          contact.contactType == "Address" && (
                            <p key={index}>{contact.details}</p>
                          )
                      )}

                    {socialLinks && socialLinks.contact && (
                      <p className="contactPage">
                        <a href={`tel:${socialLinks.contact}`}>
                          {socialLinks.contact}
                        </a>
                      </p>
                    )}
                    {/* <div class="social mt-2">
                      {" "}
                      <a
                        onClick={() =>
                          window.open(socialLinks && socialLinks.twitter)
                        }
                      >
                        <i class="ti-twitter"></i>
                      </a>{" "}
                      <a
                        onClick={() =>
                          window.open(socialLinks && socialLinks.instagram)
                        }
                      >
                        <i class="ti-instagram"></i>
                      </a>{" "}
                      <a
                        onClick={() =>
                          window.open(socialLinks && socialLinks.linkedin)
                        }
                      >
                        <i class="ti-linkedin"></i>
                      </a>{" "}
                      <a
                        onClick={() =>
                          window.open(socialLinks && socialLinks.faceBook)
                        }
                      >
                        <i class="ti-facebook"></i>
                      </a>{" "}
                    </div> */}
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="item">
                    <h3>Quick Links</h3>
                    <ul className="footer-explore-list list-unstyled">
                      <li>
                        <a
                          href="/home"
                          className={`Footer-title-list-value ${
                            activeMenu == "home" ? "active" : ""
                          }`}
                        >
                          Home
                        </a>
                      </li>
                      <li>
                        <a href="/about-us">About us</a>
                      </li>
                      <li>
                        <a href="/ContactUs">Contact Us</a>
                      </li>
                      <li>
                        <a href="/Blogs/3">Blog</a>
                      </li>
                      <li>
                        <a href="/vendor">Vendor</a>
                      </li>
                      <li>
                        <a href="/FAQ">FAQ</a>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="item">
                    <h3>Events</h3>
                    <ul className="footer-explore-list list-unstyled">
                      <li>
                        <a href="/quinceanera">Quinceanera</a>
                      </li>
                      <li>
                        <a href="/wedding">Wedding</a>
                      </li>
                      <li>
                        <a
                          className={
                            activeMenu === "corporate"
                              ? "corporate-item active"
                              : ""
                          }
                          href="/corporate"
                        >
                          Corporate / Business Meetings
                        </a>
                      </li>
                      <li>
                        <a
                          className={
                            activeMenu === "privateparties" ? "active" : ""
                          }
                          href="/privateparties"
                        >
                          Private Parties
                        </a>
                      </li>
                      <li>
                        <a
                          className={
                            activeMenu === "design-decor"
                              ? "corporate-item active"
                              : ""
                          }
                          href="/design-decor"
                        >
                          Design/Decor
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bottom">
            <div className="container">
              <div className="row">
                <div className="col-md-4">
                  <p>
                    © Copyright {new Date().getFullYear()} | Meridian | All
                    right reserved.
                  </p>
                </div>
                <div className="col-md-8">
                  <p className="right">
                    <a href="/siteMaps" style={{ marginRight: "20px" }}>
                      Site Mapping
                    </a>
                    <a href="/privacypolicy" style={{ marginRight: "20px" }}>
                      Privacy Policy
                    </a>

                    <a href="/termsandconditions">Terms and Conditions</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>

      {/* modal Inquiry */}
      <div
        className="modal custom-modal fade"
        id="inquiry"
        role="dialog"
        aria-hidden="true"
        data-bs-backdrop="static"
        style={{ zIndex: "9999" }}
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          style={{ maxWidth: "100%" }}
        >
          <div
            className="modal-content"
            style={{
              maxWidth: "1100px",
              marginLeft: "180px",
              margin: "0% auto",
              marginTop: "0px",
            }}
          >
            {loadComponent &&
              React.cloneElement(loadComponent, { key: CloseModal })}
          </div>
        </div>
      </div>
      <ToastContainer
        autoClose={2000}
        hideProgressBar={true}
        pauseOnHover={false}
        draggable={false}
        closeOnClick={false}
      />
      {/* modal Inquiry */}
    </>
  );
};

export default LayoutCorporate;
